import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import * as siteActions from '../../state/actions/sites';
import * as settingsActions from '../../state/actions/settings';

import SiteNav from './SiteNav';
import SettingsNav from './SettingsNav';

class NavBar extends Component {

    render() {

        let { sites, settings, siteActions, settingsActions } = this.props;

        return (
            <nav className="app-navbar navbar navbar-dark bg-inverse p-t-1">
                <a className="navbar-brand p-r-2" href="#">WordCamp Denver 2016</a>
                <SiteNav sites={ sites } siteActions={ siteActions } />
                <SettingsNav settings={ settings } settingsActions={ settingsActions } />
            </nav>
        )
    }

}

function mapStateToProps( state ) {
    return {
        articles: state.articles,
        settings: state.settings,
        sites: state.sites
    }
}

function mapDispatchToProps( dispatch ) {
    return {
        settingsActions: bindActionCreators( settingsActions, dispatch ),
        siteActions: bindActionCreators( siteActions, dispatch )
    }
}

export default connect( mapStateToProps, mapDispatchToProps )(NavBar);


/** WEBPACK FOOTER **
 ** ./src/components/NavBar/index.js
 **/